module.exports = __webpack_public_path__ + "static/img/movie-pass-svg.95f26fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/movie-pass-svg.svg
// module id = 713
// module chunks = 37